import React from 'react'
import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import {
  LightDropDownColumns,
  LightDropDownRow,
  LightNavDropDownWrapper,
  SolutionsColumn,
} from '../../atoms'
import {
  ArnoldSolutionIcon,
  BlenderSolutionIcon,
  C4DSolutionIcon,
  HoudiniSolutionIcon,
  MayaSolutionIcon,
  MaxSolutionIcon,
  NukeSolutionIcon,
  UnrealSolutionIcon,
  VRaySolutionIcon,
} from '../../svg'
import { LightNavDropDownPanel, MainLink, Trigger, getLocalAppOrigin, isPathActive } from './common'

interface SolutionsDropDownProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const SolutionsDropDown = ({
  currentLocale,
  currentPathname,
  origin,
}: SolutionsDropDownProps) => {
  const useGatsby = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)
  const col1 = [
    { to: '/blender-render-farm.html', label: 'Blender', Icon: BlenderSolutionIcon },
    { to: '/c4d-render-farm.html', label: 'Cinema 4D', Icon: C4DSolutionIcon },
    { to: '/arnold-render-farm.html', label: 'Arnold', Icon: ArnoldSolutionIcon },
  ]
  const col2 = [
    {
      to: '/3ds-max-render-farm.html',
      label: '3ds Max',
      Icon: MaxSolutionIcon,
    },
    { to: '/houdini-render-farm.html', label: 'Houdini', Icon: HoudiniSolutionIcon },
    { to: '/vray-render-farm.html', label: 'V-Ray', Icon: VRaySolutionIcon },
  ]
  const col3 = [
    { to: '/maya-render-farm.html', label: 'Maya', Icon: MayaSolutionIcon },
    { to: '/unreal-engine-render-farm.html', label: 'Unreal Engine', Icon: UnrealSolutionIcon },
    { to: '/nuke-render-farm.html', label: 'Nuke', Icon: NukeSolutionIcon },
  ]
  const allPaths = [...col1, ...col2, ...col3].filter((i) => i.to)
  const active = allPaths.some((i) => i.to && isPathActive(currentPathname, i.to, currentLocale))

  const cell = (item: {
    to?: string
    label: string
    Icon?: React.ComponentType<{ style?: React.CSSProperties }>
  }) => {
    const Icon = item.Icon
    const prefix = ''
    if (item.to) {
      return (
        <MainLink
          key={item.label}
          to={`${prefix}${item.to}`}
          href={`${mainOrigin}${prefix}${item.to}`}
          useGatsbyLink={useGatsby}
          locale={currentLocale}
          $highlight={isPathActive(currentPathname, item.to, currentLocale)}
        >
          {Icon && <Icon style={{ marginRight: 8 }} />}
          {item.label}
        </MainLink>
      )
    }
    return (
      <LightDropDownRow key={item.label} as='span' style={{ cursor: 'default' }}>
        {Icon && <Icon style={{ marginRight: 8 }} />}
        {item.label}
      </LightDropDownRow>
    )
  }

  return (
    <LightNavDropDownWrapper $isActive={active} $panelMinWidth={732}>
      <Trigger>{intl.get('index.header.solutions')}</Trigger>
      <LightNavDropDownPanel panelTitle={intl.get('index.header.solutions')}>
        <LightDropDownColumns>
          <SolutionsColumn>{col1.map((item) => cell(item))}</SolutionsColumn>
          <SolutionsColumn>{col2.map((item) => cell(item))}</SolutionsColumn>
          <SolutionsColumn>{col3.map((item) => cell(item))}</SolutionsColumn>
        </LightDropDownColumns>
      </LightNavDropDownPanel>
    </LightNavDropDownWrapper>
  )
}
